import { computed, inject } from "vue";
import { useRouter } from "vue-router";


const GRID_BASE_LAYOUT = "grid grid-cols-13 grid-rows-27";
const BG_PRIMARY = 'dark:bg-gray-600 bg-white';

const home = [
  {
    type: "div",
    class: "col-start-1 col-end-14 row-start-1 row-end-8",
    style: "background-image: url('https://static.xmenu.it/cache/restaurants/249/black-burger-held-front-red-background2346_w500_h281.25_cp_w800.jpg'); background-size: cover; background-position: center;",
  },
  {
    type: "div",
    class: `${BG_PRIMARY} row-start-7 row-end-28 col-start-1 col-end-14 rounded-tl-[2rem] rounded-tr-[2rem] grid grid-cols-13 grid-rows-20`,
    children: [
      {
        type: 'div',
        class: 'col-start-1 col-span-full row-span-2 row-start-2 h-28 flex justify-center items-center',
        children: [
          {
            type: 'img',
            src: '/src/assets/images/ristodemo.png',
            key: 'home-logo',
            class: "h-full"
          }
        ]
      },
      {
        type: 'icon',
        name: 'circle',
        size: '3xl',
        class: 'col-start-11 col-span-1 row-start-6 h-32 w-32 fill-none dark:stroke-gray-700 stroke-gray-200 stroke-[3px]'
      },
      {
        type: 'icon',
        name: 'circle',
        size: '2xl',
        class: 'col-start-1 col-span-1 row-start-14 h-32 w-32 fill-none dark:stroke-gray-700 stroke-gray-200 stroke-[3px]'
      },
      {
        type: 'icon',
        name: 'circle',
        size: '2xl',
        class: 'col-start-6 col-span-1 row-start-10 h-16 w-16 fill-none dark:stroke-gray-700 stroke-gray-200 stroke-[3px]'
      },
      {
        type: "home-item",
        key: "start-order",
        context: {
          title: "Ordina",
          subtitle: "Take away o consegna a domicilio",
        },
        action: "start-order",
        class: "col-end-13 col-start-2 row-start-6 row-span-3 lg:col-start-5 lg:col-span-5 xl:col-start-6 xl:col-span-3",
      },
      {
        type: "div",
        key: "div-container-z-10",
        class: "grid grid-cols-6 grid-rows-3 row-start-10 row-span-5 col-start-2 col-end-13 gap-x-2 lg:col-start-5 lg:col-span-5 xl:col-start-6 xl:col-span-3",
        children: [
          {
            type: "home-item",
            key: "restaurants",
            context: {
              title: "Ristoranti",
              subtitle: "Orari mappa, contatti",
            },
            class: "row-start-1 col-span-3 col-start-1 row-span-3 grid grid-cols-3",
          },
          {
            type: "home-item",
            key: "points",
            context: {
              title: "Raccolta punti",
              subtitle: "La tua carta fedeltà",
            },
            class: "row-start-1 col-span-3 col-start-4 row-span-3 grid grid-cols-3",
          },
        ],
      },
      {
        type: "home-item",
        key: "promotions",
        context: {
          title: "Promozioni & News",
          subtitle: "Scopri tutte le promozioni e le novità in corso",
        },
        theme: {
          button: 'pulse'
        },
        class: "col-start-2 col-end-13 row-start-15 row-span-3 bg-transparent! shadow-none dark:text-white lg:col-start-5 lg:col-span-5 xl:col-start-6 xl:col-span-3",
      },
    ]
  },
  {
    type: "language-switcher",
    key: "language-switcher",
    class: "col-start-11 col-span-2 row-start-2 row-end-4 flex items-center justify-center",
  },
  {
    type: "avatar",
    key: "home_img",
    context: {
      src: "https://picsum.photos/200/300",
    },
    hidden: true,
    class:
    "col-start-11 col-end-13 row-start-2 row-end-4 h-[3.5rem] w-[3.5rem] rounded-[2rem] object-cover object-center flex items-center justify-center",
  },
];

const categories = [
  {
    type: 'app-bar',
    id: 'app-bar'
  },
  {
    type: 'div',
    children: {
      store: 'categories',
      component: 'category',
    }
  }
];

export default {
  install: (app, options) => {
    app.provide('resources', {
      home,
      categories
    })
  }
}


export function useResource() {

  let resources = inject("resources");
  let route = useRouter();

  route = route.currentRoute.value;

  const elements = computed(() => {
    let resourceName = route.meta?.name ?? route.name;
    return resources[resourceName] ?? [];
  });

  return {
    elements,
    route,
    resources,
  };
}
